import { EventEmitter } from 'events';
import { tmpl } from '@/utils/util-extent';

const { $ } = window;

export default class LocationListItem extends EventEmitter {
  constructor($container, data, opt) {
    super();
    this.data = data;
    this.map = null;
    this.opt = $.extend({
      isCheckable: false, // 是否開啟check選項 for 預約
    }, opt);

    this.weekday = new Array(7);
    this.initWeekName();

    // 資訊內容 一般查詢 以及 選擇預約 template-map-item
    this.$item = $(tmpl($('#template-map-item').html(), this.data));
    if (this.opt.isCheckable === false) {
      // localtion
      // 建置每天的營業時間
      this.$item.find('.store-info-item ul').empty().append(this.layoutWeekhtml());
      // 顯示目前時間間距 呈現營業中或休息中
      this.$item.find('.store-info-item .status').empty().append(this.getNowTimeStatus());
      this.$item.find('.store-info-item .current-open').empty().append(this.getNowTimeString());
      // 判斷顯示項目
      this.markerItemshtml();
      // 專屬車輛
      if (this.data.exclusiveCars.length > 0 && this.data.dateInfo.TYP === 'S') {
        this.$item.find('.store-marks').append(`<li class="mark-item"><i class="icon-toyota-location-showroom mark-icon"></i><span>${this.data.exclusiveCars.join('、')}</span></li>`);
      }
      if (!this.data.dist) this.$item.find('.store-distance').remove();
    } else {
      // 一般預約&預約保養
      // reservation預約保養
      if (this.opt.isViewMarkerItems) {
        this.markerItemshtml();
      }
      $(this.$item.find('input')).on('click', (e) => {
        $(e).prop('checked', true);
        this.emit(LocationListItem.CHECK, this.data);
      });
    }


    // 綁定事件
    $(this.$item.find('.store-content')).on('click', this.onInfoClick.bind(this));
    // $(this.$item.find('.item-map-bar .icon')).on('click', this.toggleMapImg.bind(this));

    // this.$map = $(this.$item.find('.item-map'));
    $container.append(this.$item);
  }

  onInfoClick() {
    this.active();
    this.emit(LocationListItem.CLICK, this.data.key);
  }

  active() {
    $('.store-list .store-item').removeClass('active');
    this.$item.addClass('active');
  }

  initWeekName() {
    this.weekday[0] = '星期日';
    this.weekday[1] = '星期一';
    this.weekday[2] = '星期二';
    this.weekday[3] = '星期三';
    this.weekday[4] = '星期四';
    this.weekday[5] = '星期五';
    this.weekday[6] = '星期六';

    // this.weekday[d.getDay()];
  }

  getWeekName(offsetDay = 0) {
    const timeNow = new Date();
    timeNow.setDate(timeNow.getDate() + offsetDay);
    return this.weekday[timeNow.getDay()];
  }

  getNowTimeStatus(offsetDay = 0) {
    const timeNow = new Date();
    timeNow.setDate(timeNow.getDate() + offsetDay);
    const shiftIndex = timeNow.getDay() - 1;
    const isSunDay = timeNow.getDay() === 0;
    const { dateInfo } = this.data;

    if (isSunDay) {
      if (dateInfo.SDISFLAG === 'Y') {
        return LocationListItem.checkTimeStatue(dateInfo.SDTIME);
      }
      return '公休。';
    }
    if (dateInfo.Wflags[shiftIndex] === 'Y') {
      return LocationListItem.checkTimeStatue(dateInfo.ODTIME);
    }
    return LocationListItem.checkTimeStatue(this.data.time);
  }

  // 預設值為0 時會進入 getNextTimeString
  // getNextTimeString 如果遇到計算其他天營業時間會導回getNowTimeString
  getNowTimeString(offsetDay = 0) {
    const timeNow = new Date();
    timeNow.setDate(timeNow.getDate() + offsetDay);
    const day = timeNow.getDay();
    const shiftIndex = day - 1;
    const isSunDay = day === 0;
    const { dateInfo } = this.data;
    const isGetOtherDay = offsetDay !== 0;

    if (isSunDay) {
      if (dateInfo.SDISFLAG === 'Y') {
        if (isGetOtherDay) {
          return dateInfo.SDTIME;
        }
        return this.getNextTimeString(dateInfo.SDTIME);
      }
      return '';
    }
    if (dateInfo.Wflags[shiftIndex] === 'Y') {
      if (isGetOtherDay) {
        return dateInfo.ODTIME;
      }
      return this.getNextTimeString(dateInfo.ODTIME);
    }


    if (isGetOtherDay) {
      return this.data.time;
    }
    return this.getNextTimeString(this.data.time);
  }

  getNextTimeString(timeSpan) {
    const timeNow = new Date();
    const timeSplit = timeSpan.split('~');
    if (timeSplit.length !== 2) return '';
    const start = parseInt(timeSplit[0].replace(':', ''), 10);
    const stop = parseInt(timeSplit[1].replace(':', ''), 10);
    const now = timeNow.getHours() * 100 + timeNow.getMinutes();
    if (now >= start && now <= stop) {
      return timeSpan;
    }
    if (now < start) {
      return `${timeSplit[0]} 營業`;
    }
    let weekName;
    let timeString;
    for (let index = 1; index < 7; index += 1) {
      if (this.getNowTimeStatus(index) !== '公休') {
        timeString = this.getNowTimeString(index);
        weekName = this.getWeekName(index);
        break;
      }
    }
    return `${weekName} ${timeString.split('~')[0]} 營業`;
  }

  static checkTimeStatue(timeSpan) {
    const timeNow = new Date();
    const timeSplit = timeSpan.split('~');
    if (timeSplit.length !== 2) return '公休。';
    const start = parseInt(timeSplit[0].replace(':', ''), 10);
    const stop = parseInt(timeSplit[1].replace(':', ''), 10);
    const now = timeNow.getHours() * 100 + timeNow.getMinutes();
    if (now >= start && now <= stop) {
      return '營業中。';
    }
    return '休息中。';
  }

  layoutWeekhtml() {
    let weekName;
    let timeString;
    // const weekTime = `<li class="store-timetable-item"><span class="week">{{ weekName }}</span> <span class="time">{{ timeString }}</span></li>`;
    let weekhtml = '';
    const sundayIndex = 0;

    this.data.dateInfo.Wflags.forEach((e, i) => {
      const index = i + 1;
      if (e === 'Y') {
        weekName = this.weekday[index];
        timeString = this.data.dateInfo.ODTIME;
      } else {
        weekName = this.weekday[index];
        timeString = '公休';
      }
      weekhtml += LocationListItem.weekHtmlTemplate(weekName, timeString);
    });
    if (this.data.dateInfo.SDISFLAG === 'Y') {
      weekName = this.weekday[sundayIndex];
      timeString = this.data.dateInfo.SDTIME;
    } else {
      weekName = this.weekday[sundayIndex];
      timeString = '公休';
    }
    weekhtml += LocationListItem.weekHtmlTemplate(weekName, timeString);
    if (this.data.dateInfo.HDISFLAG === 'Y') {
      weekName = '國定假日';
      timeString = this.data.dateInfo.HDTIME;
      weekhtml += LocationListItem.weekHtmlTemplate(weekName, timeString);
    }

    return weekhtml;
  }

  static weekHtmlTemplate(weekName, timeString) {
    return `<li class="store-timetable-item"><span class="week">${weekName}</span> <span class="time">${timeString}</span></li>`;
  }

  markerItemshtml() {
    // 判斷顯示項目
    if (this.data.ebisflag && this.data.dateInfo.TYP === 'F') this.$item.find('.store-marks').append('<li class="mark-item"><i class="icon icon-day mark-icon"></i></li>');
    if (this.data.ntisflag && this.data.dateInfo.TYP === 'F') this.$item.find('.store-marks').append('<li class="mark-item"><i class="icon icon-night mark-icon"></i></li>');
    if (this.data.aed) this.$item.find('.store-marks').append('<li class="mark-item"><i class="icon-toyota-aed mark-icon"></i></li>');
    if (this.data.exclusive && this.data.dateInfo.TYP === 'F') this.$item.find('.store-marks').append('<li class="mark-item"><i class="icon-toyota-location-service mark-icon"></i></li>');
    if (this.data.bpisflag && this.data.dateInfo.TYP === 'F') this.$item.find('.store-marks').append('<li class="mark-item"><i class="icon icon-panel-beat mark-icon"></i></li>');
    if (this.data.carHeightType === '1' && this.data.dateInfo.TYP === 'F') {
      this.$item.find('.store-marks').append(`<li class="icon-img"><img src="/images/element/car-height-1.svg"> <span class="text-dark">服務廠限高${this.data.limitHeight}cm</span></li>`);
    }
  }
}
LocationListItem.CLICK = 'LocationListItem.Click';
LocationListItem.CHECK = 'LocationListItem.Check';
